import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://sanchidataportal.com/api4/',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem('apikey');
    if (apiKey) {
      config.url += (config.url.includes('?') ? '&' : '?') + `apikey=${apiKey}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
